import { ICReportWidget } from '@/pages/funds/ic-report/components/ICReportWidget'
import { DownloadRawDataButtons } from '@/pages/funds/ic-report/components/composites/scenario-analysis-buttons'
import { ProtectionScenarioChart as ProtectionScenarioChartNew } from '@/pages/funds/ic-report/components/primitives/charts/ProtectionScenarioChartNew'
import { BaseICReportPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { labels } from '@/pages/funds/ic-report/constants'
import { protection } from '@/react-query/queries/ic-report/hooks'

export type ProtectionScenarioProps = BaseICReportPrimitive & {}

export const ProtectionScenario: React.FC<ProtectionScenarioProps> = () => {
  return (
    <div className="flex items-stretch gap-4">
      {/* <ICReportWidget
        widget={{
          component: ProtectionScenarioChart,
          query: protection.useHistoricalEvents,
          key: 'protection.scenario',
          labels: labels.protection.scenario_analysis,
          sidebarTitle: 'sdfsdf',
        }}
      /> */}
      <ICReportWidget
        widgetButtons={[
          <DownloadRawDataButtons
            filePrefix={`protection`}
            query={protection.useHistoricalEventsNew}
          />,
        ]}
        widget={{
          component: ProtectionScenarioChartNew,
          query: protection.useHistoricalEventsNew,
          key: 'protection.scenario',
          labels: labels.protection.scenario_analysis,
          sidebarTitle: 'sdfsdf',
        }}
      />
    </div>
  )
}
